import React from 'react'
import Practice from '../Coding/iPractice'

function Coding() {
  return (
    <>
        <Practice />
    </>
  )
}

export default Coding
